import {Floorplan} from "../../../api/apiClient";
import {Chip, Stack} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import {FLOOR_TABS_PADDING_BOTTOM_PX, PANEL_GUTTER} from "./useNavLayout";

export interface FloorTabsProps {
    floorPlans: Floorplan[];
    selectedFloorIndex: number;
    onSelectFloor: (floorIndex: number) => void;
}

/** Floor selection for the floorplan. Selecting a floor still travels to that floor's default viewpoint. */
export function FloorTabs(props: FloorTabsProps) {
    const {floorPlans, selectedFloorIndex, onSelectFloor} = props;

    // A single floor has nothing to switch between.
    if (floorPlans.length < 2) {
        return <></>;
    }

    return <Stack direction={"row"} spacing={1}
                  sx={{flexShrink: 0, overflowX: "auto", px: PANEL_GUTTER,
                      pb: `${FLOOR_TABS_PADDING_BOTTOM_PX}px`}}>
        {floorPlans.map((floorPlan, floorIndex) => {
            const isSelected = floorIndex === selectedFloorIndex;

            return <Chip key={"floor-tab-" + floorPlan.name + "-" + floorIndex}
                         label={floorPlan.imageHeader}
                         clickable
                         aria-pressed={isSelected}
                         onClick={() => onSelectFloor(floorIndex)}
                         color={isSelected ? "primary" : "default"}
                         variant={isSelected ? "filled" : "outlined"}
                         icon={isSelected ? <CheckIcon/> : undefined}
                         sx={{flexShrink: 0}}/>;
        })}
    </Stack>
}
